// extracted by mini-css-extract-plugin
module.exports = {"bg":"banner_bg__1E1CL","content":"banner_content__1YbNn","parallelogramSpan":"banner_parallelogramSpan__coAD4","title":"banner_title__2EK93","chamada":"banner_chamada__1jdLu"};